
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artwork-assistant",
      function () {
        return require("private-next-pages/artwork-assistant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artwork-assistant"])
      });
    }
  